// Client-side input cleaners — UX/first-layer only, NOT a security boundary.
// Backend validation + output encoding remain the real defense.
//
// Authored as CommonJS so a dependency-free `node` test can require it directly;
// webpack/babel still allow `import { cleanText } from "@/utils/inputCleaners"`.
//
// Patterns are built from \u-escaped strings (not regex literals) so the source
// stays pure ASCII — no invisible control/zero-width characters live in the file.

// Allow-list for free text (names, address, company, city, notes, codes):
// Latin + Cyrillic letters, digits, German umlauts/diaeresis, space and hyphen.
const TEXT_ALLOWED =
  "A-Za-z0-9\\u0400-\\u04FF \\-\\u00A8\\u00C4\\u00CB\\u00CF\\u00D6\\u00DC\\u00DF\\u00E4\\u00EB\\u00EF\\u00F6\\u00FC";
const SPECIAL_CHARS = new RegExp("[^" + TEXT_ALLOWED + "]+", "g");

// Emojis + control chars + zero-width/bidi + variation selectors + angle
// brackets. Safe for email/phone (keeps @ . +).
const UNSAFE_SOURCE =
  "[\\u0000-\\u001F\\u007F-\\u009F\\u200B-\\u200F\\u202A-\\u202E\\u2060-\\u206F\\uFE00-\\uFE0F\\uFEFF<>]" +
  "|\\uD83C[\\uDC00-\\uDFFF]|\\uD83D[\\uDC00-\\uDFFF]|\\uD83E[\\uDC00-\\uDFFF]" +
  "|[\\u2190-\\u21FF\\u2300-\\u27BF\\u2B00-\\u2BFF\\u20D0-\\u20FF]";
// Variation selectors / combining marks are stripped on purpose; control chars too.
// eslint-disable-next-line no-misleading-character-class, no-control-regex
const UNSAFE = new RegExp(UNSAFE_SOURCE, "g");

const cleanText = (s) => (s == null ? "" : String(s)).replace(SPECIAL_CHARS, "");
const cleanNumbers = (s) => (s == null ? "" : String(s)).replace(/[^0-9]/g, "");
const cleanUnsafe = (s) => (s == null ? "" : String(s)).replace(UNSAFE, "");

module.exports = { cleanText, cleanNumbers, cleanUnsafe, SPECIAL_CHARS, UNSAFE };
